import {
  ElementIndexContextProvider,
  ElementType,
  useQueryStateContext,
  useVisualComponentsContext,
} from '../../contexts';
import { CombinatorInput } from './CombinatorInput';
import { AddButton } from '../criteria/AddButton';
import { CriteriaRenderer } from '../criteria/CriteriaRenderer';
import { useQueryCombinatorState, useQueryCriteriasState } from '../../hooks/query';
import { QueryErrorBanner } from '../QueryErrorBanner';
import { QueryWrapper } from '../QueryWrapper';
import { QueryWarningBanner } from '../QueryWarningBanner';
import { EditReadInput } from './EditReadInput';
import { UndoButton } from './UndoButton';
import { RedoButton } from './RedoButton';

export const QueryRenderer = () => {
  const { QueryLayout, QueryBuilderLoadingState } = useVisualComponentsContext();
  const { criterias: criteriaArray } = useQueryCriteriasState();
  const { queryCombinator, setQueryCombinator } = useQueryCombinatorState();
  const { isReadOnly = false, setIsReadOnly, isLoading } = useQueryStateContext();

  const Criteria = criteriaArray.map((criteria, index: number) => (
    <ElementIndexContextProvider key={criteria.id} index={index} type={ElementType.Criteria}>
      <CriteriaRenderer
        isFirstElement={index === 0}
        criteriaAmount={criteriaArray.length}
        queryCombinator={queryCombinator}
      />
    </ElementIndexContextProvider>
  ));

  const CombinatorSelect = (
    <CombinatorInput value={queryCombinator} onChange={setQueryCombinator} />
  );

  const Add = <AddButton />;
  const Undo = <UndoButton />;
  const Redo = <RedoButton />;

  const EditReadSelect = <EditReadInput value={isReadOnly} onChange={setIsReadOnly} />;

  return (
    <QueryWrapper>
      {isLoading ? (
        <QueryBuilderLoadingState />
      ) : (
        <>
          <QueryWarningBanner />
          <QueryErrorBanner />
          <QueryLayout
            CombinatorSelect={CombinatorSelect}
            Criteria={Criteria}
            Add={Add}
            EditReadSelect={EditReadSelect}
            UndoButton={Undo}
            RedoButton={Redo}
          />
        </>
      )}
    </QueryWrapper>
  );
};
